import React,{ useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import VideoTestimonials from '../components/VideoTestimonials';
import PaymentMethods from '../components/PaymentMethods';
import CookiesPopup from '../components/CookiesPopup';
import WhatsappChat from '../components/WhatsappChat';
import ScrollTop from '../components/ScrollTop';
import ContactIcon from '../components/ContactIcon';

import Title from "../components/Title";
import AboutBanner from '../components/about/AboutBanner';
import ContactUs from '../components/ContactUs';
import AboutTheFounder from '../components/about/AboutTheFounder';
import StudentsCounter from  '../components/StudentsCounter';
import WhatWeOffer from '../components/about/WhatWeOffer';
import WhyChooseUs from '../components/about/WhyChooseUs';

const About = () => {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant"
        });
      }, []);
        return(
            <>
            <Title title="About Us | CAD AND RENDER" />
            <Header />

            <AboutBanner />

            <ContactIcon />
            <WhatsappChat />
            <ScrollTop />
            <CookiesPopup />

            <StudentsCounter />
            <AboutTheFounder />
            <WhatWeOffer />
            <WhyChooseUs />
            <ContactUs />
            <VideoTestimonials />

            <PaymentMethods />
         
            <Footer />
           
            </>
        )
}


export default About;